import React from "react";
import {
  ResponsiveContainer,
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";

const data = [
  {
    x: 2022,
    y: 2,
    company: "Pratian Technologies",
    role: "Frontend Development Engineer",
    duration: "Aug 2022 - Apr 2023",
  },
  {
    x: 2023,
    y: 1,
    company: "Profcyma Global Solutions",
    role: "Frontend Development Engineer",
    duration: "Jun 2023 - Present",
  },
];

const WorkExperienceChart = () => {
  return (
    <div style={{ width: "100%", height: 180 }}>
      <ResponsiveContainer>
        <ScatterChart margin={{ top: 20, right: 20, left: 20, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" />

          <XAxis
            type="number"
            dataKey="x"
            domain={[2022, 2026]}
            tickCount={5}
          />

          <YAxis
            type="number"
            dataKey="y"
            hide
            domain={[0, 3]}
          />

          <Tooltip
            cursor={{ strokeDasharray: "3 3" }}
            formatter={(value, name, props) => [
              <>
                <strong>{props.payload.company}</strong>
                <br />
                {props.payload.role}
                <br />
                {props.payload.duration}
              </>,
            ]}
          />

          <Scatter data={data}>
            {data.map((entry, index) => (
              <Cell key={index} fill="#6f2dbd" />
            ))}
          </Scatter>
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WorkExperienceChart;